import { Box } from '@mui/system';

function TitleLayout(props:any) {
  const { children, ...BoxProps } = props;
  return (<Box {...BoxProps} my={3}
    display='flex'
    flexDirection='column'
    gap={4}>
    {children}
  </Box>
  );
}

export default TitleLayout;